<template>
  <div class="container">
    <div class="top">
      <div class="top_con">
        <div class="top_col span1">
          <dl>
            <dt>我们的愿景</dt>
            <dd>成为国内领先的技术解决方案提供商</dd>
            <dd>领航行业的技术变革</dd>
            <dd>为未来的智慧商业绘制蓝图</dd>
          </dl>
        </div>
        <div class="top_col span2">
          <dl>
            <dt>联系我们</dt>
            <dd>联系电话：15601853960</dd>
            <dd>业务合作：yuanqixian@gousii.com</dd>
          </dl>
        </div>
        <div class="top_col span3">
          <dl>
            <dt>公司地址</dt>
            <dd>苏州公司地址：苏州市工业园区裕新路同程大厦B栋706</dd>
            <dd>集团总部地址：上海市浦东新区五星路707弄12号</dd>
          </dl>
        </div>
        <div class="top_col span4">
          <a-row class="wechat" type="flex" justify="space-around">
            <a-col class="items" :span="12">关注我们</a-col>
            <a-col class="items items2" :span="12">扫码合作</a-col>
          </a-row>
        </div>
      </div>
    </div>
    <div class="bottom">
      <p>
        Copyright © 构思网络科技有限公司 All Rights Reserved
        <img style="width: 16px;margin:0 5px 0 20px;" src="../assets/image/record-icon.png" alt="">
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=32059002006017" rel="noreferrer"
          target="_blank">苏公网安备32059002006017</a>
        工信部备案号：<a href="https://beian.miit.gov.cn/">苏ICP备2024067465号</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PublicFooter",
};
</script>

<style lang="less" scoped>
.top {
  padding: 60px 20px 0;
  box-sizing: border-box;
  background-color: #242525;
  height: 255px;

  .top_con {
    width: 1200px;
    margin: 0 auto;
    color: #fff;
    overflow: hidden;

    .top_col {
      float: left;
    }

    .span1 {
      width: 30%;
    }

    .span2 {
      width: 25%;
    }

    .span3 {
      width: 25%;

      dd {
        width: 200px;
      }
    }

    .span4 {
      width: 20%;
      padding: 0 10px;
    }

    dt {
      font-size: 16px;
      margin-bottom: 12px;
    }

    dd {
      color: #999;
      font-size: 14px;
      margin-bottom: 12px;
    }

    .wechat {
      .items {
        color: #eee;
        width: 90px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        position: relative;
        top: 120px;

        &:after {
          content: "";
          width: 90px;
          height: 90px;
          background: url("https://ow-resource.gousii.com/image/QRCode1.jpg") no-repeat center;
          background-size: contain;
          position: absolute;
          top: -100px;
          left: 0;
        }

        &.items2:after {
          background-image: url("https://ow-resource.gousii.com/image/QRCode2.png");
        }
      }
    }
  }
}

.bottom {

  p {
    line-height: 20px;
    text-align: center;
    color: #999;
    background-color: #292929;
    margin: 0;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      color: #999;
      margin-right: 10px;
    }
  }
}

@media screen and (max-width: 768px) {
  .container {
    padding-bottom: 81px;
  }

  .top {
    height: 620px;

    .top_con {
      width: 100%;

      .top_col {
        width: 100%;
      }

      .span3 dd {
        width: 100%;
      }

      .span4 {
        width: 220px;
        height: 200px;
      }
    }
  }
}
</style>
